<template>
    <div>
        <h3>招贤纳士</h3>
        <!--招聘职位-->
        <div class="mt2">

            <div id="control">
                <table width="100%" height="30" border="0" cellpadding="0" cellspacing="0">
                    <tbody>
                        <tr>
                            <td width="33%" height="40" align="left" bgcolor="#FFFFFF" class="font20"><strong>商务拓展经理</strong></td>
                            <td width="53%" rowspan="2" align="right" bgcolor="#FFFFFF"></td>
                            <td width="14%" rowspan="2" align="right" bgcolor="#FFFFFF" class="font20" id="testtab"><a href="#" onclick="Effect('test',this.parentNode.id);">∧</a></td>
                        </tr>
                        <tr>
                            <td align="left" bgcolor="#FFFFFF">运营部 </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="test" class="test">
                <table width="100%" height="130" border="0" cellpadding="4" cellspacing="0" bgcolor="#FFFFFF">
                    <tbody>
                        <tr>
                            <td colspan="3" valign="top">
                                <p>部门：运营部&nbsp;&nbsp;工作地点：北京&nbsp;&nbsp;招聘人数：3</p><br>

                                <p>
                                    岗位职责：<br>
                                    1. 根据公司战略开发药企、药批等上游客户资源，及时引进下游客户需求的品种；<br>
                                    2. 负责撰写商务合作方案，独立完成商务谈判及合同签订，主导并推进合作的进度，及时解决合作过程中的沟通问题；<br>
                                    3. 挖掘客户需求，协助客户进行产品推广活动，负责与市场、运营人员对接，确保合作项目顺利进行；<br>
                                    4. 负责客户关系维护，关注客户反馈，定期回访客户，及时将获得的数据和分析结果反馈给公司相关部门；<br>
                                    5. 完成上级安排的其他工作。
                                </p>

                                <p>
                                    任职资格：<br>
                                    1. 具有3年以上医药行业药品采购、销售类工作经验；<br>
                                    2. 熟悉药品流通环节及医药工业业务流程，懂医药工业产品，熟悉药品品类；<br>
                                    3. 逻辑条理清晰、工作执行细心缜密、注重细节和责任感强；<br>
                                    4. 善于协调内、外部资源，应变能力强，人际沟通能力强；<br>
                                    5. 熟悉电商行业者优先。
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div id="control">
                <table width="100%" height="30" border="0" cellpadding="0" cellspacing="0">
                    <tbody>
                        <tr>
                            <td width="33%" height="40" align="left" bgcolor="#FFFFFF" class="font20"><strong>asp.net开发工程师</strong></td>
                            <td width="53%" rowspan="2" align="right" bgcolor="#FFFFFF"></td>
                            <td width="14%" rowspan="2" align="right" bgcolor="#FFFFFF" class="font20" id="test1tab"><a href="#" onclick="Effect('test1',this.parentNode.id);">∧</a></td>
                        </tr>
                        <tr>
                            <td align="left" bgcolor="#FFFFFF">技术部</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="test1" class="test">
                <table width="100%" height="130" border="0" cellpadding="4" cellspacing="0" bgcolor="#FFFFFF">
                    <tbody>
                        <tr>
                            <td colspan="3" valign="top">
                                <p>部门：产品技术部&nbsp;&nbsp;工作地点：北京&nbsp;&nbsp;招聘人数：3</p><br>

                                <p>
                                    岗位职责：<br>
                                    1. 根据系统设计，按要求完成自己负责模块的详细设计；<br>
                                    2. 根据项目采用的标准，进行编码；<br>
                                    3. 测试代码，编写测试用例与测试程序；<br>
                                    4. 在开发相应阶段完成详细设计文档、源代码组织说明、源代码、测试用例等文档的书写；<br>
                                    5. 完成部门经理安排的其他工作。
                                </p>

                                <p>
                                    任职资格：<br>
                                    1. 学历背景：正规大学本科或以上学历，计算机相关专业毕业；<br>
                                    2. 工作经验：2年以上.NET(C#)开发及设计经验；<br>
                                    3. 技术能力：<br>
                                    -基础技术扎实，熟悉面向对象的设计方法；<br>
                                    -熟悉.Net Framework 2.0或.Net Framework3.5框架下C#的开发；<br>
                                    -能独立编写 ASP.NET(c#),winForm(c#)程序，熟练使用VS2005或vs2008开发工具，熟悉JavaScript(包括AJAX)、XML、Web Service、WCF等；<br>
                                    -熟悉MVC、Entity Framework、Nhibernate等框架；<br>
                                    -熟悉SqlServer或Oracle数据库开发，良好的SQL编写能力，并有相应的项目经验；<br>
                                    -熟悉电子商务网站业务流程，并具备一定的策划分析能力，良好的逻辑思维和理解能力，良好的编程风格及文档编写习惯；
                                    <br>
                                    4. 综合素质：为人诚信、正直、责任心强，具有良好的职业道德；善于协作与沟通，优秀的团队合作精神，学习能力强。
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div id="control">
                <table width="100%" height="30" border="0" cellpadding="0" cellspacing="0">
                    <tbody>
                        <tr>
                            <td width="33%" height="40" align="left" bgcolor="#FFFFFF" class="font20"><strong>客服专员</strong></td>
                            <td width="53%" rowspan="2" align="right" bgcolor="#FFFFFF"></td>
                            <td width="14%" rowspan="2" align="right" bgcolor="#FFFFFF" class="font20" id="test2tab"><a href="#" onclick="Effect('test2',this.parentNode.id);">∧</a></td>
                        </tr>
                        <tr>
                            <td align="left" bgcolor="#FFFFFF">客服部</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="test2" class="test">
                <table width="100%" height="130" border="0" cellpadding="4" cellspacing="0" bgcolor="#FFFFFF">
                    <tbody>
                        <tr>
                            <td colspan="3" valign="top">
                                <p>部门：客服部&nbsp;&nbsp;工作地点：北京&nbsp;&nbsp;招聘人数：5</p><br>

                                <p>
                                    岗位职责：<br>
                                    1. 负责公司直营终端销售业务及订单处理事宜；<br>
                                    2. 接听热线电话，与客户保持良好互动，并记录事件工单；<br>
                                    3. 定期电话回访客户，维护客户关系；<br>
                                    4. 跟进客户问题解决情况，协调有关部门、人员尽快解决客户问题，并对问题进行全程跟踪，及时反馈客户。
                                </p>

                                <p>
                                    任职资格：<br>
                                    1. 良好的服务意识、耐心和责任心，工作积极主动；<br>
                                    2. 普通话良好，表达流利；<br>
                                    3. 熟悉互联网，熟练操作Office办公软件；<br>
                                    4. 中专以上学历，应届毕业生亦可。
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div id="control">
                <table width="100%" height="30" border="0" cellpadding="0" cellspacing="0">
                    <tbody>
                        <tr>
                            <td width="33%" height="40" align="left" bgcolor="#FFFFFF" class="font20"><strong>项目招商经理</strong></td>
                            <td width="53%" rowspan="2" align="right" bgcolor="#FFFFFF"></td>
                            <td width="14%" rowspan="2" align="right" bgcolor="#FFFFFF" class="font20" id="test3tab"><a href="#" onclick="Effect('test3',this.parentNode.id);">∧</a></td>
                        </tr>
                        <tr>
                            <td align="left" bgcolor="#FFFFFF">销售部</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="test3" class="test">
                <table width="100%" height="130" border="0" cellpadding="4" cellspacing="0" bgcolor="#FFFFFF">
                    <tbody>
                        <tr>
                            <td colspan="3" valign="top">
                                <p>部门：销售部&nbsp;&nbsp;工作地点：北京&nbsp;&nbsp;招聘人数：2</p><br>

                                <p>
                                    岗位职责：<br>
                                    1. 掌握管辖地区各类商业渠道产品目录、产品价格、产品库存信息；<br>
                                    2. 扩大重点产品的商业采购渠道，为公司“药聚多”平台寻找货源和低价渠道，降低采购成本；<br>
                                    3. 根据公司平台终端采购销售情况调整商品报价政策，严格执行采购询价制度，保证货源充足；<br>
                                    4. 策划、组织、执行公司移动平台终端供货促销补贴政策和活动。
                                </p>

                                <p>
                                    任职资格：<br>
                                    1. 对新型移动互联网药品采购供销平台有强烈的职业兴趣；<br>
                                    2. 药学相关专业，本科以上学历，2年以上相关工作经验；<br>
                                    3. 有较强的解决问题能力、组织协调能力、工作责任心强；<br>
                                    4. 能够独立处理、解决问题，吃苦耐劳，具备团队合作精神。
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div id="control">
                <table width="100%" height="30" border="0" cellpadding="0" cellspacing="0">
                    <tbody>
                        <tr>
                            <td width="33%" height="40" align="left" bgcolor="#FFFFFF" class="font20"><strong>区域终端地推服务经理</strong></td>
                            <td width="53%" rowspan="2" align="right" bgcolor="#FFFFFF"></td>
                            <td width="14%" rowspan="2" align="right" bgcolor="#FFFFFF" class="font20" id="test5tab"><a href="#" onclick="Effect('test5',this.parentNode.id);">∧</a></td>
                        </tr>
                        <tr>
                            <td align="left" bgcolor="#FFFFFF">销售部</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="test5" class="test">
                <table width="100%" height="130" border="0" cellpadding="4" cellspacing="0" bgcolor="#FFFFFF">
                    <tbody>
                        <tr>
                            <td colspan="3" valign="top">
                                <p>部门：销售部&nbsp;&nbsp;工作地点：北京&nbsp;&nbsp;招聘人数：10</p><br>

                                <p>
                                    岗位职责：<br>
                                    1. 招募标准：有医药第三终端从业经验的个人；<br>
                                    2. 地区销售潜力：月销售潜力5万以上；<br>
                                    3. 创新思维能力：认同汉宁恒丰医药电子商务平台；<br>
                                    4. 市级代理有团队者优先。
                                </p>

                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
        <!--招聘职位结束-->
    </div>
</template>
<script>
export default {
  name: 'Join'
}
</script>
